<template>
  <div class="formbody">
    <div class="select-all">
      <el-col :span="12">
        <div
          class="expressBtn all"
          :class="{ is_active: mode == 2 }"
          @click="handleTab(2)"
        >
          图文发布
        </div>
      </el-col>
      <el-col :span="12">
        <div
          class="expressBtn notAll"
          :class="{ is_active: mode == 0 }"
          @click="handleTab(0)"
        >
          待买清单发布
        </div>
      </el-col>
    </div>
    <el-form :model="form" ref="form" :rules="rules">
      <!--<el-form-item label prop="name" style="height:40px;">
          <YueDanIpt model="name" :object="form" placeholder="商品名称"></YueDanIpt>
        </el-form-item>-->
      <!--<ul class="error-messages" style="margin-top:20px;" v-if="!isEmptyErrors">
          <li v-for="(error,index) in errors" :key="index">{{error.message}}</li>
      </ul>-->
      <div>
      <div style="display: flex; margin-top: 20px">
        <div style="width: 50%;">
          <el-form-item style="height: 50px" prop="merchantInfo">
            <el-autocomplete
              style="width: 400px; height: 50px"
              v-model="form.merchantInfo"
              :fetch-suggestions="querySearch"
              placeholder="商家" @select="handleAutoSelect"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="服务类型：" prop="serviceType">
            <el-radio class="service" v-model="form.serviceType" label="1"
              >下单</el-radio>
            <el-radio
              class="service"
              v-model="form.serviceType"
              style="margin-left: 10px"
              label="2"
              >下单+转运</el-radio
            >
            <!--<el-switch class="customSwitch"
              v-model="form.serviceTypeBoolean"
              active-color="#333"
              active-text="下单+转运"
              inactive-text="下单"
              @change="handleServiceTypeChange">
            </el-switch>-->
          </el-form-item>
          <el-form-item label="收货地址：" prop="address">
            <div class="address">
              <AddAddressDialog
                v-if="!form.address"
                v-on:success="addAddress"
                :support_transport_service="form.serviceType"
              >
                <span
                  class="pointer"
                  style="margin-bottom: 10px"
                  @click="showForm = true"
                  v-if="!form.address"
                >
                  <span class="add-tip"><i class="el-icon-circle-plus-outline"></i> 添加地址</span></span
                >
              </AddAddressDialog>
              <AddAddressDialog
                :address="form.address"
                v-if="form.address"
                v-on:success="addAddress"
                :support_transport_service="form.serviceType"
              >
                <span
                  class="pointer"
                  style="margin-bottom: 10px"
                  @click="showForm = true"
                  v-if="form.address">
                  <span class="add-tip">编辑地址</span></span>
              </AddAddressDialog>
            </div>
            <div v-if="form.address">
              <SingleAddress
                class="address-info"
                :address="form.address"
              ></SingleAddress>
            </div>
          </el-form-item>
          <el-form-item label="" prop="price">
            <div style="width: 400px">
              <YueDanIpt
                model="price"
                :object="form"
                placeholder="下单金额(含服务费)"
                :append="currency.value"
                :reg="/^\d+\.?\d{0,2}$/"
                @blur="form.price?formError.price=false:formError.price=true"
              ></YueDanIpt>
            </div>
          </el-form-item>
          <el-form-item label="" v-if="form.serviceType==2">
            <div style="width: 400px">
              <el-select
                class="customHeightSelect"
                v-model="form.internationalFeeMode"
                placeholder="国际运费"
                style="width: 190px; height: 50px"
              >
                <el-option label="包邮" value="2"></el-option>
                <el-option label="按重量实收" value="1"></el-option>
              </el-select>
              <div style="width: 190px; float: right">
                <YueDanIpt
                  model="internationalFee"
                  :object="form"
                  placeholder="已付国际运费"
                  :append="currency.value"
                  :reg="/^\d+\.?\d{0,2}$/"
                  :disabled="form.internationalFeeMode == 2"
                ></YueDanIpt>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="" prop="showbuyer">
            <div class="hoverCustomInputDiv">
              <!--<YueDanIpt
                model="showbuyer"
                :object="form"
                :buyer="true"
                placeholder="买单客户"
              ></YueDanIpt>-->
              <el-input class="customInput" :class="{'underline':validatedBuyer}" @blur="validateBuyerName"
                v-model="form.showbuyer"
                placeholder="买单客户">
              </el-input>
              <span class="el-input__suffix">
                <span v-if="!validatedBuyer && form.showbuyer" class="el-input__suffix-inner" @click="validateBuyerName">
                  <i class="el-select__caret el-input__icon el-icon-search"></i>
                </span>
                <span v-if="validatedBuyer && form.showbuyer" class="el-input__suffix-inner" @click="clearCustomInput">
                  <i class="el-select__caret el-input__icon el-icon-circle-close"></i>
                </span>
              </span>
            </div>
          </el-form-item>
          <el-form-item>
            <div style="width: 400px">
              <el-select
                class="customHeightSelect"
                v-model="form.resource"
                placeholder="任务来源"
                style="width: 400px"
              >
                <el-option label="微信" value="1"></el-option>
                <el-option label="支付宝" value="2"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item>
            <div style="width: 400px">
              <el-select
                class="customHeightSelect"
                v-model="form.offline_payment"
                placeholder="支付方式"
                style="width: 400px"
              >
                <el-option label="私下支付" value="1"></el-option>
                <el-option label="系统支付" value="0"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <!--<el-form-item>
            <div style="width: 400px">
              <el-input class="customInput" v-model="form.joyorders_promo_code" placeholder="任务优惠码">
              </el-input>
            </div>
          </el-form-item>-->
          <el-form-item prop="remark">
            <div style="width: 400px">
              <el-input placeholder="备注" type="textarea" :rows="3" v-model="form.remark"></el-input>
            </div>
          </el-form-item>
        </div>
        <div style="width: 50%">
          <div style="width: 90%; height: 100%; margin: auto; position: relative">
            <div v-if="mode==2" style="display:flex;flex-wrap: wrap;">
                <div class="uploadLI" v-for="(item,index) in form.good_image_list" :key="index">
                        <img :src="item" style="width:100%;height:100%;object-fit:contain">
                        <div class="operations on">
                            <div class="operation" style="margin-right: 10px;">
                                <div class="operation replace"  @click.stop="replace(index)"></div>
                            </div>
                            <div class="operation del" @click.stop="del(index)">

                            </div>
                        </div>
                </div>
                <div class="uploadLI">
                        <div class="selectUpload" @click="handleUpload">
                                <div class="upload-demo"></div>
                                <div class="upload-title">上传图片</div>
                                <div class="voucherFooter">
                                    支持 jpg、jpeg、png 格式，大小不能超过20M
                                </div>
                        </div>
                        <div class="form_error" v-show="formError.good_image_list" style="position:relative;top:10px;">
                          商品图片是必填项，至少上传一张
                        </div>
                </div>
            </div>
            <div v-if="mode==0" style="color:#606266">
              <div style="margin-bottom:10px;line-height:40px;">
                <!--<el-select
                class="customHeightSelect"
                v-model="form.mode0_currency"
                placeholder="货币"
                style="width: 48%; height: 50px" @change="handleCurrencyChange"
              >
                <el-option v-for="(item,index) in CURRENCIES" :label="item.value" :value="index" :key="index"></el-option>
              </el-select>
              <div style="width:48%;">
                <YueDanIpt
                  reg="/^\d+\.?\d{0,4}$/"
                  model="mode0_rate"
                  :object="form"
                  placeholder="实时汇率"
                ></YueDanIpt>-->
                <YueDanIpt
                :dropdownList="CURRENCIES"
                v-on:dropdownChange="handleCurrencyChange"
                model="mode0_rate"
                :object="form"
                placeholder="实时汇率"
                :append="form.mode0_currency.value"
                :reg="/^\d+\.?\d{0,4}$/"
              ></YueDanIpt>
              </div>
              <div style="height:40px;line-height:40px;margin-bottom:10px;">
                <span
                  class="pointer" :class="{'disabled':addNewGoodsDisabled}"
                  style="margin-bottom: 10px"
                  @click.stop="addNewGoods"
                >
                  <span class="add-tip"><i class="el-icon-circle-plus-outline"></i> 新增商品</span></span
                >
              </div>
              <div v-for="(item,index) in form.mode0_goodList" :key="index" class="gooditem" :class="{'editMode':item.editMode}"
              @click.stop="handleGoodsClick(item)">
              <!--<ul class="error-messages" v-if="goodsErrors.length">
                  <li v-for="(error,index) in goodsErrors" :key="index">{{error}}</li>
              </ul>-->
                <div class="goods_info" :class="{'noeditMode':!item.editMode}">
                  <div v-show="item.editMode" class="goods_info_row" style="margin-bottom: 10px;position:relative;">
                    <el-input placeholder="商品图片网址" v-model="item.picture"></el-input>
                    <el-upload 
                      :action="API_HOST + '/api/order_v2.php?api=upload_picture'"
                      :on-success="handleUploadSuccess"
                      :headers="headers"
                      name="picture"
                      style="position:absolute;right:5px;top:10px;">
                      <el-button size="small" type="info">本地上传</el-button>
                    </el-upload>
                  </div>
                  <div v-show="item.editMode" class="goods_info_row editMode">                    
                    <div class="goods_params">
                      <div class="goods_params_row" style="width:calc(100% - 150px)">
                        <div style="margin-bottom:10px;">
                          <el-input placeholder="商品名称" v-model="item.name" @input="checkGoodError(item,'name')"></el-input>
                        </div>
                        <div class="form_error" v-show="goodError.name || goodError.number" style="position: relative;top: -6px;height:16px;">
                            {{goodError.name?'商品名称是必填项':''}}
                        </div>
                        <div>
                          <el-input placeholder="商品规格" v-model="item.spec"></el-input>
                        </div>
                        <div class="form_error" v-show="goodError.price" style="position: relative;top: 2px;height:16px;">
                        </div>
                      </div>
                      <div class="goods_params_row right" style="width:130px;text-align:right;">
                        <div>
                          <el-input style="margin-bottom:10px;" placeholder="数量" v-model="item.number" @blur="checkNumber(item,index)"></el-input>
                        </div>
                        <div class="form_error" v-show="goodError.name || goodError.number" style="position: relative;top: -6px;height:16px;">
                            {{goodError.number?'商品数量是必填项':''}}
                        </div>
                        <div>
                          <el-input placeholder="价格" v-model="item.price" @input="checkGoodError(item,'price')">
                            <template slot="append">{{form.mode0_currency.value}}</template>
                          </el-input>
                          <div class="form_error" v-show="goodError.price" style="position: relative;top: 2px;height:16px;">
                            {{goodError.price?'商品价格是必填项':''}}
                        </div>
                        </div>                                            
                      </div> 
                    </div>
                  </div>
                  <div v-show="!item.editMode" class="goods_info_row">
                    <div class="goods_image">
                      <img v-if="item.picture" :src="item.picture" style="width:100%;height:100%;object-fit:contain"/>
                      <img v-if="!item.picture" src="../../ico/uploadpic@2x.png" style="width:100%;height:100%;object-fit:contain"/>                  
                      <!--<div class="goods_number" v-if="item.number">
                        {{item.number}}
                      </div>-->
                    </div>
                    <div class="goods_params noeditMode" :class="{'hasPicture':item.picture}">
                      <div class="goods_params_row noeditMode">
                        <div>
                          <p style="padding-left: 10px;color:#333;">{{item.name}}</p>
                        </div>
                        <div>
                          <p style="padding-left: 10px;color:#888">{{item.spec}}</p>
                        </div>
                        <div style="position:relative;">
                          <button class="goods_delete" type="button" @click.stop="deleteGoods(index)">删 除</button>                                   
                              <label style="float:right;">
                                {{form.mode0_currency.symbol}}{{$decimalFormat((+item.price),2)}}
                                <label style="margin:0 5px;">x</label>
                                {{item.number}}
                              </label>                                        
                        </div> 
                      </div>
                    </div>
                  </div>
                  <div v-show="item.editMode" class="goods_info_row">
                    <el-button class="nohover" style="width:48%;height:50px;" @click.stop="cancelGoods(item,index)">取 消</el-button>
                    <el-button style="width:48%;height:50px;" type="info" @click.stop="confirmGoods(item)">保 存</el-button>
                  </div>
                  <!--<div class="goods_info_delete">
                    <el-button style="width:100%;height:50px;" type="info" @click.stop="deleteGoods(index)">删 除</el-button>
                  </div>-->
                </div>
              </div>
              <div v-if="goodsTotalPrice>0" class="priceInfo_div">
                <div class="priceInfo_row">
                  <div>
                    商品
                  </div>
                  <div>
                    {{form.mode0_currency.symbol}}{{goodsTotalPrice}}
                  </div>
                </div>
                <div class="priceInfo_row" :class="{'editMode':priceEditMode.tax_amount_editMode}" style="cursor:pointer;" @click="openEditMode('tax_amount_editMode')">
                  <div>
                    税费
                  </div>
                  <div class="priceInfo_row_right">
                    {{form.mode0_currency.symbol}}<label v-show="!priceEditMode.tax_amount_editMode" style="cursor:pointer">{{$decimalFormat((+tax_amount),2)}}</label>
                    <el-input ref="tax_amount_editMode" style="width:31%;" v-show="priceEditMode.tax_amount_editMode" placeholder="税费" 
                    v-model="tax_amount" @blur="closeEditMode('tax_amount_editMode')">
                    </el-input>
                  </div>
                </div>
                <div class="priceInfo_row" :class="{'editMode':priceEditMode.other_amount_editMode}" style="cursor:pointer;" @click="openEditMode('other_amount_editMode')">
                  <div>
                    其他费用
                  </div>
                  <div class="priceInfo_row_right">
                    {{form.mode0_currency.symbol}}<label v-show="!priceEditMode.other_amount_editMode" style="cursor:pointer">{{$decimalFormat((+other_amount),2)}}</label>
                    <el-input ref="other_amount_editMode" style="width:31%" v-show="priceEditMode.other_amount_editMode" placeholder="其他费用" 
                    v-model="other_amount" @blur="closeEditMode('other_amount_editMode')">
                    </el-input>
                  </div>
                </div>
              </div>
              <div v-if="goodsTotalPrice>0" class="priceInfo_div">
                <div class="priceInfo_row">
                  <div>
                    商家小计
                  </div>
                  <div>
                    {{form.mode0_currency.symbol}}{{priceInfo.merchantTotalPrice}}
                  </div>
                </div>
                <div class="priceInfo_row" :class="{'editMode':priceEditMode.service_amount_editMode}" style="cursor:pointer;" @click="openEditMode('service_amount_editMode')">
                  <div>
                    服务费
                    <el-tooltip placement="top" effect="light">
                      <p slot="content">{{service_fee_desc}}</p>
                      <button type="button" class="round_button">
                        <i class="el-icon-question"></i>
                      </button>
                    </el-tooltip>
                  </div>
                  <div class="priceInfo_row_right">
                    {{form.mode0_currency.symbol}}<label v-show="!priceEditMode.service_amount_editMode" style="cursor:pointer">{{$decimalFormat((+service_amount),2)}}</label>
                    <el-input ref="service_amount_editMode" style="width:31%" v-show="priceEditMode.service_amount_editMode" placeholder="服务费" 
                    v-model="service_amount" @blur="closeEditMode('service_amount_editMode')">
                    </el-input>
                  </div>
                </div>
              </div>
              <div v-if="goodsTotalPrice>0" class="priceInfo_div">
                <div class="priceInfo_row">
                  <div>
                    下单金额（含服务费）
                  </div>
                  <div>
                    {{form.mode0_currency.symbol}}{{priceInfo.totalPrice}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </el-form>
    <div style="width: 30%;margin: auto;margin-top: 20px;">
        <el-button :disabled="isChecking || addNewGoodsDisabled" class="block" type="info" @click="submitForm('form')" :loading="publishLoading">发 布</el-button>
    </div>
    <div class="bg-black" v-if="uploadDialogVisible">
              <div  class="dialog mobile-dialog" style="margin-top: 15vh">
                <div class="text-center redirct">
                    <div class="sourcePicture text" :class="source =='远程'?'source':''" @click="remote()">远程图片</div><div class="text">或</div><div @click="local()" class="sourcePicture text" :class="source =='本地'?'source':''">本地图片</div>
                    <div class="remote" v-if="source=='远程'">
                      <!--<ul class="error-messages" v-if="!isEmptyErrors">
                        <li>{{error}}</li>
                      </ul>-->
                      <el-input ref="remotePicture" v-model="goods.remotePicture" placeholder="请复制图片地址或手动输入" style="margin-bottom:10px;"></el-input>
                      <el-button size="small" type="info" @click="confirm(goods)">确定</el-button><div class="del" @click="onUploadCancel()">取消</div>
                    </div>
                    <uploader
                    v-if="source =='本地'"
                    icon="ico ico-uploadpic mt15"
                    :item="goods"
                    name="picture"
                    :action="API_HOST + '/api/order_v2.php?api=upload_picture'"
                    v-on:onUploadSuccess="onUploadSuccess"
                    v-on:onUploadCancel="onUploadCancel()"></uploader>
                </div>
              </div>
            </div>
  </div>
</template>

<script>
import api from "../../services/api.js";
import Uploader from '../../components/Uploader'
import AddressDialog from "./address/AddressDialog";
import AddAddressDialog from "./address/AddAddressDialog";
import SingleAddress from "./address/SingleAddress";
import YueDanIpt from "../../components/YueDanIpt";
import Loading from "../../components/Loading";
import { CURRENCIES,API_HOST,specOrder,SPEC_MAPPER } from "../../services/constant";

export default {
  name: "PublishTask",
  props: [],
  components: {
    SingleAddress: SingleAddress,
    AddressDialog: AddressDialog,
    AddAddressDialog: AddAddressDialog,
    YueDanIpt: YueDanIpt,
    Loading: Loading,
    Uploader:Uploader
  },
  computed: {
    taskInfo () {
	    return this.$store.state.taskInfo
    },
    /*goodsTotalPrice (){
      let total=0;
      this.form.mode0_goodList.forEach((g)=>{
        total+=(+g.price)*(+g.number)
      })
      return total.toFixed(2)
    }*/
  },
  watch:{
    /*goodsTotalPrice:{
         handler(val, oldVal){
             if(this.mode==0){
               this.tax_amount=(+val)*(+this.tax_amount_percent);
               this.service_amount=((+val)+this.tax_amount)*this.flexFeeRate/100+(+this.fixedFee)
               this.priceInfo.merchantTotalPrice=((+val)+this.tax_amount+this.other_amount).toFixed(2)
               this.priceInfo.totalPrice=((+this.priceInfo.merchantTotalPrice)+(+this.service_amount)).toFixed(2)
               this.form.price=((+this.priceInfo.totalPrice)*(+this.form.mode0_rate)).toFixed(2)
             }
         },
     },*/
     tax_amount:{
       handler(val, oldVal){
             if(this.mode==0){
               this.service_amount=((+val)+(+this.goodsTotalPrice))*this.flexFeeRate/100+(+this.fixedFee)
               this.priceInfo.merchantTotalPrice=this.$decimalFormat(((+this.goodsTotalPrice)+(+val)+this.other_amount),2)
               this.priceInfo.totalPrice=this.$decimalFormat(((+this.priceInfo.merchantTotalPrice)+(+this.service_amount)),2)
               this.form.price=this.$decimalFormat(((+this.priceInfo.totalPrice)*(+this.form.mode0_rate)),2)
             }
         },
     },
     other_amount:{
       handler(val, oldVal){
             if(this.mode==0){
               this.priceInfo.merchantTotalPrice=this.$decimalFormat(((+this.goodsTotalPrice)+(+this.tax_amount)+(+val)),2)
               this.priceInfo.totalPrice=this.$decimalFormat(((+this.priceInfo.merchantTotalPrice)+(+this.service_amount)),2)
               this.form.price=this.$decimalFormat(((+this.priceInfo.totalPrice)*(+this.form.mode0_rate)),2)
             }
         },
     },
     service_amount:{
       handler(val, oldVal){
             if(this.mode==0){
               this.priceInfo.totalPrice=this.$decimalFormat(((+this.priceInfo.merchantTotalPrice)+(+val)),2)
               this.form.price=this.$decimalFormat(((+this.priceInfo.totalPrice)*(+this.form.mode0_rate)),2)
             }
         },
     },
     'form.mode0_rate':{
       handler(val, oldVal){
             if(this.mode==0){
               this.form.price=this.priceInfo.totalPrice?this.$decimalFormat(((+this.priceInfo.totalPrice)*(+val)),2):''
             }
         },
     }
  },
  data() {
    return {
      service_fee_desc:'目前没有商家',
      goodsErrors:[],
      addNewGoodsDisabled:false,
      tax_amount_percent:0,
      flexFeeRate:0,
      isChecking:false,
      validatedBuyer:false,
      isNewBuyer:false,
      publishLoading:false,
      API_HOST:API_HOST,
      CURRENCIES: CURRENCIES,
      mode: 2,
      currency: {
        value: "CNY",
        symbol: "￥",
      },
      uploadDialogVisible:false,
      goods:{},
      source: '远程',
      isEmptyErrors: true,
      error: '',
      good_image_list_index:0,
      form: {
          //age:'',
        name: "",
        buyer:"",
        showbuyer:"",
        buyer_id:"",
        mobile:"",
        serviceType: "2",
        //serviceTypeBoolean:true,
        address: "",
        resource: "",
        merchant: "",
        merchantInfo:"",
        remark: "",
        price: "",
        orderStatus: "",
        currency: null,
        currency_symbol: null,
        internationalFee: "0",
        internationalFeeMode: "1",
        good_image_list:[],
        offline_payment:'1',
        mode0_currency: {value: 'CNY', symbol: '¥', name: '人民币', name_en: 'Chinese Yuan Renminbi'},
        mode0_rate:0,
        mode0_goodList:[],
      },
      curItem:{},
      oldEditItem:{},
      exchangeRates:[],
      priceEditMode:{tax_amount_editMode:false,service_amount_editMode:false,other_amount_editMode:false},
      priceInfo:{},
      tax_amount:0,
      service_amount:0,
      other_amount:0,
      fixedFee:0,
      headers:{},
      goodsTotalPrice:'',
      errors:[],
      goodError:{
        name:false,
        number:false,
        spec:false,
        price:false
      },
      formError:{
        merchant:false,
        address:false,
        price:false,
        //showbuyer:false,
        good_image_list:false,
      },
      rules: {
        showbuyer: [
          { validator: this.validateBuyerName, trigger: 'blur' }
        ],
        merchantInfo:[
          { required: true, message: '商家是必填项'},
        ],
        address:[
         { required: true, message: '地址是必填项'}, 
        ],
        price:[
          { required: true, message: '下单金额是必填项'}, 
        ],
        showbuyer:[
          { required: true, message: '买单客户是必填项'}, 
        ],
      }
    };
  },
  mounted(){
    this.headers.token = this.$localStorage.get('token')
    api.getExchangeRates(this).then(res => {
      this.exchangeRates = res.body.result
    })
  },
  methods: {
    checkGoodError(item,prop){
      console.log('checkGoodError',item[prop])
      if(item[prop])
        this.goodError[prop]=false
      else
        this.goodError[prop]=true
    },
    checkMoney(str) {
            var regex = /^(([+]?\d*$)|(^[+]?\d+(\.\d+)?$))/;
            if(regex.test(str)) {
                return true;
            } else {
                return false;
            }
        },
    cancelGoods(item,index){
      this.goodsErrors=[];
      this.goodError.name=false;
      this.goodError.spec=false;
      this.goodError.number=false;
      this.goodError.price=false;
      for(let p in this.oldEditItem){
        item[p]=this.oldEditItem[p]
      }
      item.editMode=false;
      this.addNewGoodsDisabled=false;
      if(item.number==0){
        this.form.mode0_goodList.splice(index,1)
      }
    },
    confirmGoods(item){
      console.log("confirmGoods")
      item.discounted_price=item.price
      this.goodsErrors=[];
      if(!item.name){
        this.goodError.name=true
        this.goodsErrors.push(1);
      }
      if(!item.number){
        this.goodError.number=true
        this.goodsErrors.push(2);
      }
      if(!item.price){
        this.goodError.price=true
        this.goodsErrors.push(3);
      }
      /*if(!item.spec){
        this.goodError.spec=true
        this.goodsErrors.push(4);
      }*/
      /*if(item.price && !this.checkMoney(item.price)){
        this.goodsErrors.push('金额格式不正确')
      }*/
      if(this.goodsErrors.length)
        return;
      this.curItem=null;
      let total=0;
      this.form.mode0_goodList.forEach((g)=>{
        total+=(+g.price)*(+g.number)
      })
      this.goodsTotalPrice = this.$decimalFormat(total,2);
      this.tax_amount=(+this.goodsTotalPrice)*(+this.tax_amount_percent);
      this.service_amount=((+this.goodsTotalPrice)+this.tax_amount)*this.flexFeeRate/100+(+this.fixedFee)
      this.priceInfo.merchantTotalPrice=this.$decimalFormat(((+this.goodsTotalPrice)+this.tax_amount+this.other_amount),2)
      this.priceInfo.totalPrice=this.$decimalFormat(((+this.priceInfo.merchantTotalPrice)+(+this.service_amount)),2)
      this.form.price=this.$decimalFormat(((+this.priceInfo.totalPrice)*(+this.form.mode0_rate)),2)
      item.editMode=false;
      this.addNewGoodsDisabled=false;
      if(item.number==0){
        this.form.mode0_goodList.splice(index,1)
      }
    },
    closeEditMode(name){
      this.priceEditMode[name]=false
      this.$forceUpdate()
    },
    openEditMode(name){
      this.priceEditMode[name]=true
      this.$forceUpdate()
      this.$nextTick(()=>{
          this.$refs[name].focus();
      })
    },
    checkNumber(item,index){
      if((+item.number)===0){
        this.form.mode0_goodList.splice(index)
      }
      this.addNewGoodsDisabled=false;
    },
    handleUploadSuccess: function(response, file, fileList) {
      this.isProgressing = false
      if (response.status !== 'ok') {
        this.$message.error('上传失败：'+response.result)
        return;
      }
      this.curItem.picture=response.result
      this.$forceUpdate()
    },
    deleteGoods(index){
      this.form.mode0_goodList.splice(index,1);
      let total=0;
      this.form.mode0_goodList.forEach((g)=>{
        total+=(+g.price)*(+g.number)
      })
      this.goodsTotalPrice = this.$decimalFormat(total,2);
      this.tax_amount=(+this.goodsTotalPrice)*(+this.tax_amount_percent);
      this.service_amount=((+this.goodsTotalPrice)+this.tax_amount)*this.flexFeeRate/100+(+this.fixedFee)
      this.priceInfo.merchantTotalPrice=this.$decimalFormat(((+this.goodsTotalPrice)+this.tax_amount+this.other_amount),2)
      this.priceInfo.totalPrice=this.$decimalFormat(((+this.priceInfo.merchantTotalPrice)+(+this.service_amount)),2)
      this.form.price=this.$decimalFormat(((+this.priceInfo.totalPrice)*(+this.form.mode0_rate)),2)
    },
    handleAllEditMode(){
      this.form.mode0_goodList.forEach((i)=>{
        i.editMode=false;
      })
    },
    handleGoodsClick(item){
      if(!item.editMode){
        if(this.curItem){
          for(let p in this.oldEditItem){
            this.curItem[p]=this.oldEditItem[p]
          }
        }
        this.form.mode0_goodList.forEach((i)=>{
          i.editMode=false;
        })
        item.editMode=true
        this.curItem=item;
        this.oldEditItem=JSON.parse(JSON.stringify(item))
      }
    },
      /*handleServiceTypeChange(){
        this.form.serviceType=this.form.serviceTypeBoolean?"2":"1";
      },*/
      addNewGoods(){
        if(this.addNewGoodsDisabled)
          return;
        this.addNewGoodsDisabled=true;
        this.form.mode0_goodList.forEach((i)=>{
          i.editMode=false;
        })
        let newGoods={};
        newGoods.price='';
        newGoods.number=1;
        newGoods.editMode=true;
        this.curItem=newGoods;
        this.oldEditItem=JSON.parse(JSON.stringify(newGoods))
        this.oldEditItem.number=0;
        this.form.mode0_goodList.push(newGoods)
      },
      handleTab(mode){
        this.mode = mode;
        this.$nextTick(()=>{
          if(mode==0){
            if(!this.form.merchantInfo)
              this.form.mode0_rate=1;
            if(this.form.mode0_goodList.length==0){
              this.addNewGoods();
            }
          }
          else
            this.form.mode0_rate=1;
        })
      },
      handleCurrencyChange(currency){
        let cur=currency.value;
        for(let i=0,length=this.exchangeRates.length;i<length;i++){
          if(cur==this.exchangeRates[i].currency){
            this.form.mode0_rate=this.exchangeRates[i].rate;
            break;
          }
        }
        this.form.mode0_currency = Object.assign({}, currency)
      },
      handleUpload(){
        this.good_image_list_index=-1;
        if(this.goods.remotePicture)
          this.goods.remotePicture="";
        this.uploadDialogVisible=true;
        this.$nextTick(()=>{
          this.$refs.remotePicture.focus();
        })
      },
      handleAutoSelect(item){
        console.log('merchant',this.form.merchantInfo);
        this.formError.merchant=false;
        this.form.merchant=item;
        //if(this.mode==0){
          for(let i=0,length=this.CURRENCIES.length;i<length;i++){
            if(item.currency==this.CURRENCIES[i].value){
              this.form.mode0_currency=this.CURRENCIES[i];
              break;
            }
          }
          let cur=this.form.mode0_currency.value;
          for(let i=0,length=this.exchangeRates.length;i<length;i++){
            if(cur==this.exchangeRates[i].currency){
              this.form.mode0_rate=this.exchangeRates[i].rate;
              break;
            }
          }
          //如果是加拿大，则要加上税费
          this.tax_amount_percent=(item.id === '4474' ? 0.05 : 0);

          //获取商家的服务费率
          api.getMerchantDetail(this,{id:item.id}).then((res)=>{
              let theMerchant=res.body.result;
              let flexFeeRate = this.form.service_type==1?theMerchant.single_service_rate:theMerchant.buyer_service_rate
              this.flexFeeRate = +flexFeeRate.substr(0,flexFeeRate.length-1)
              this.fixedFee = this.form.service_type==1?theMerchant.single_fixed_amount:theMerchant.buyer_fixed_amount
              let single_service_rate=Number(theMerchant.single_service_rate.replace('%',''));
              this.service_fee_desc=`${theMerchant.name_cn || theMerchant.name} 下单服务费为${single_service_rate>=0?'商家金额的'+single_service_rate+'%':''}${single_service_rate>=0&&theMerchant.single_fixed_amount>0?'+':''}${theMerchant.single_fixed_amount>0?this.form.mode0_currency.symbol+theMerchant.single_fixed_amount+this.form.mode0_currency.value:''}`
            })
        //}
      },
      initParams(data){
          let p={};
          p.type=this.mode;
          p.service_type=+this.form.serviceType;
          p.business_id=this.form.merchant.id;
		      p.business_name=this.form.merchant.value;
          if(this.mode==2){
            p.currency=this.currency.value;
            p.currency_symbol=this.currency.symbol;
          }
          else{
            p.currency=this.form.mode0_currency.value;
            p.currency_symbol=this.form.mode0_currency.symbol;
          }
          //p.transport_amount=0;
          p.transport_amount_charge_type=this.form.internationalFeeMode;
          p.package_forwarding_fee=this.form.internationalFee;
          if(this.mode==2){
            p.amount=this.form.price?this.$decimalFormat((+this.form.price),2):0;
            p.tax_amount=0;
            p.service_amount=0;
            p.total_amount=p.amount+p.tax_amount+p.service_amount;
            p.rmb_total_amount=p.amount+p.tax_amount+p.service_amount;
          }
          else{
            p.amount=+this.goodsTotalPrice;
            p.tax_amount=+this.tax_amount;
            p.other_amount=+this.other_amount;
            p.service_amount=+this.service_amount;
            p.total_amount=p.amount+p.tax_amount+p.service_amount+p.other_amount;
            p.rmb_total_amount=p.total_amount*this.form.mode0_rate;
          }
          p.remark=`${this.form.resource==1?'微信下单':'淘宝下单'}${this.form.remark?' | '+this.form.remark:''}`;
          //if(this.form.joyorders_promo_code)
          //  p.joyorders_promo_code=this.form.joyorders_promo_code
          if(this.mode==2)
            p.good_image_list=this.form.good_image_list;
          else{
            p.goods_list=this.form.mode0_goodList;
          }
          p.conditions={};
          if(this.mode==2)
            p.conditions.rate=1;
          else
            p.conditions.rate=this.form.mode0_rate;
          p.address_info=this.form.address;
          p.address_id=0;
          //p.offline_payment=1;
          p.offline_payment=this.form.offline_payment;
          if(this.isNewBuyer){
            if(isNaN(this.form.buyer))
                p.conditions.buyer_name=this.form.buyer;
            else{
                p.conditions.mobile_country_code=86;
                p.conditions.mobile=this.form.buyer;
            }
          }
          else{
             p.conditions.buyer_id=this.form.buyer_id;
             p.conditions.buyer_name=this.form.buyer;
          }
          p.conditions.need_create_buyer_account=this.isNewBuyer?1:0;
          p.source=0;//0表示为PC端提交任务
          return p;
      },
      submitForm(formName) {
        let isValid=true;
        this.$refs[formName].validate((valid) => {
          isValid=valid;
        });
        if(this.mode==2){
          if(this.form.good_image_list.length==0){
            this.formError.good_image_list=true;
          }
        }
        else{
          if(this.form.mode0_goodList.length==0){
            this.formError.mode0_goodList=true;
          }
        }
        if(isValid)
          this.submit()
      },
    async submit(){
        this.isEmptyErrors=true;
        this.errors=[];
        /*this.$refs['form'].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });*/
        /*if(!this.form.merchant){
          this.errors.push({message:'商家是必填项'});
          this.isEmptyErrors=false;
        }
        if(!this.form.address){
          this.errors.push({message:'地址是必填项'});
          this.isEmptyErrors=false;
        }
        if(!this.form.price){
          this.errors.push({message:'下单金额是必填项'});
          this.isEmptyErrors=false;
        }
        if(!this.form.showbuyer){
          this.errors.push({message:'买单客户是必填项'});
          this.isEmptyErrors=false;
        }
        if(this.mode==2){
          if(this.form.good_image_list.length==0){
            this.errors.push({message:'至少上传一个商品图片'});
            this.isEmptyErrors=false;
          }
        }
        else{
          if(this.form.mode0_goodList.length==0){
            this.errors.push({message:'至少需要一个商品'});
            this.isEmptyErrors=false;
          }
        }
        if(!this.isEmptyErrors){
          return;
        }*/
        let params=this.initParams(this.form)
        let res = await api.post(this, {
            path: 'order.php',
            data: params,
            loading: 'loading',
            api: 'add_by_single'
        })

        if(res.body.result){
            //console.log(res.body.result)
            this.$store.commit('clearTaskInfo')
            this.$localStorage.remove('addressName')
            this.$router.push({ path: '/Complete', query: {isSingle: true, order_no: res.body.result.order_no}})              
        }
    },
    async validateBuyerName(){
      let value=this.form.showbuyer;
      if (!value) {
        this.form.buyer_id = '0'
        return
      }
      let keyword = value.replace(/(^\s*)|(\s*$)/g, '')
      if (!keyword) {
        this.form.buyer_id = '0'
        return
      }
      this.isChecking=true;
      let { body } = await api.getBuyerList(this, {
        keyword: keyword
      })
      let res = body.result || []
      if (res.length != 1) {
        this.isNewBuyer=true;
        this.form.buyer=this.form.showbuyer
        this.form.showbuyer=this.form.showbuyer+'@新用户'
      }
      else{
        this.form.showbuyer=res[0].mobile+'@'+res[0].username
        this.form.buyer=res[0].username
        this.form.buyer_id = res[0].account_id
      }
      this.validatedBuyer=true;
      this.isChecking=false;
    },
    clearCustomInput(){
      this.form.showbuyer=''
      this.form.buyer=''
      this.form.buyer_id = '0'
      this.validatedBuyer=false;
    },
    /*async validateBuyerName(rule, value, callback){
      console.log(value)
      if (!value) {
        this.form.buyer_id = '0'
        return callback()
      }
      let keyword = value.replace(/(^\s*)|(\s*$)/g, '')
      if (!keyword) {
        this.form.buyer_id = '0'
        return callback()
      }
      let { body } = await api.getBuyerList(this, {
        keyword: keyword
      })
      let res = body.result || []
      if (res.length != 1) {
        this.isNewBuyer=true;
        this.form.buyer=this.form.showbuyer
        this.form.showbuyer=this.form.showbuyer+'@新用户'
        return callback()
      } 
      this.form.showbuyer=res[0].mobile+'@'+res[0].username
      this.form.buyer=res[0].username
      this.form.buyer_id = res[0].account_id
      callback()
    },*/
    addAddress(){
        this.form.address=this.taskInfo.address_info
        this.formError.address=false;
    },
    remote () {
      this.source = '远程'
    },
    local () {
      this.source = '本地'
      //this.isEmptyErrors = true
      this.error = ''
    },
    del(index){
        this.form.good_image_list.splice(index,1)
    },
    replace(index){
        this.form.good_image_list_index=index;
        this.uploadDialogVisible=true
    },
    handleBeforeUpload (file) {
      let isLt2M = file.size / 1024 / 1024 < 20
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 20MB!',
          type: 'warning'
        })
      }
    },
    uploadPicture () {
      this.uploadDialogVisible = true
    },
    confirm () {
      if (!this.goods.remotePicture) {
        //this.isEmptyErrors = false
        this.error = '图片地址不能为空'
        return
      }
      this.form.good_image_list.push(this.goods.remotePicture)
      this.uploadDialogVisible = false
      this.isEmptyErrors = true
      this.error = ''
    },
    onUploadCancel () {
      this.uploadDialogVisible = false
      this.source = '远程'
      //this.isEmptyErrors = true
      this.error = ''
    },
    onUploadSuccess: function (res) {
      let result = res.response.result
      if(this.good_image_list_index==-1)
        this.form.good_image_list.push(result)
      else{
          this.form.good_image_list[this.good_image_list_index]=result;
     }
      this.uploadDialogVisible = false
      this.source = '远程'
      this.formError.good_image_list=false;
    },
    async querySearch(queryString, cb){
      let query = {
        keyword: queryString
      }
      let res = await api.searchBusiness(this,query)
      let arr = []
      res.body.result.forEach(item => {
        arr.push({value:item.name,id:item.id,currency:item.default_currency})
      })
      cb(arr)
    },
    dropdownChange(currency) {
      this.currency = Object.assign({}, currency);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .pointer.disabled{
      color:#ccc;
    }
    .hoverCustomInputDiv{
      width: 400px;
      position:relative;
    }
    .hoverCustomInputDiv .underline input{
      text-decoration: underline;
    }
    .hoverCustomInputDiv .el-input__suffix{
      cursor: pointer;
      display: none;
    }
    .hoverCustomInputDiv:hover .el-input__suffix{
      display: block;
    }
    .formError{
      color:#ff4650;
      font-size:12px;
    }
    .formbody {
    width: 90%;
    margin: auto;
    }
    .mobileImg {
    height: 60px !important;
    width: 60px !important;
    margin-right: 5px;
    }
    .select-all {
    width: 50%;
    margin: auto;
    overflow: hidden;
    border-radius: 3px;
    .expressBtn {
            text-align: center;
            display: inline-block;
            border: 1px solid #ccc;
            box-sizing: border-box;
            width: 100%;
            padding: 15px 0;
            cursor: pointer;
            &.is_active {
            background-color: #333;
            border: 1px solid transparent;
            color: #fff;
            }
            &.all {
            border-right: none;
            }
            &.notAll {
            border-left: none;
            }
        }
    }
    .uploadLI {
            border: 1px dashed #d9d9d9;
            width:200px;
            height: 200px;
            position:relative;
            margin-right:10px;
            padding:5px;
            border-radius: 2px;
            cursor: pointer;
            .selectUpload {
                height:100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
            }

            .upload-demo {
                display: inline-block;
                height: 28px;
                width: 30px;
                background: url('../../ico/upload@2x.png');
                background-size: 38px 38px;
                background-position: -4px -6px;
                margin: auto;
                margin-top: 0;
                margin-bottom: 20px;
            }
            .upload-title {
                text-align: center;
                font-size: 16px;
                color: #666666;
            }
            .voucherFooter {
                margin-top: 20px;
                color: #666666;
                font-size: 8px;
                text-align: center;   
            }
            .operations {
                display: none;
                position: absolute;
                left: 15px;
                bottom: 15px;
                z-index: 100;
                width:106px;
                height:30px;

                .operation {
                    float: left;
                    width:30px;
                    height:30px;
                    background:rgba(51,51,51,1);
                    border-radius:15px;
                    cursor: pointer;
                }
                .replace {
                    background: url('../../ico/replace@2x.png');
                    background-size: cover;
                }
                .del {
                    background: url('../../ico/delete@2x.png');
                    background-size: cover;
                }
            }
    }
    .uploadLI:hover{
        .on{
            display:block;
        }
    }
    .bg-black {
        position: fixed;
        display: block;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
        margin: 0;
        z-index: 2111;
        background: rgba(0,0,0,.3);
    }
    .dialog {
        width: 450px;
        position: relative;
        margin: 0 auto 50px;
        background: #ffffff;
        box-shadow: 0 1px 3px rgba(0,0,0,.3);
        padding: 20px;
    }  
    .redirct {
    font-size:24px;
    line-height:33px;
    .source {
      color: #337ab7;
    }

    .text {
      display: inline-block;
      margin-right: 10px;
    }
    .sourcePicture:hover {
      color: #337ab7;
      cursor: pointer;
    }

    .remote {

      .error-messages {
        display: block;
        background-color: #fff1f1;
        padding: 10px;
        text-align: center;
        color: #ff4650;
        line-height: 17px;
        margin-bottom: 10px;
        border-radius: 5px;
        li {
          font-size: 12px;
        }
      }
      .del {
        padding: 0px 15px;
        display: inline-block;
        border: 1px solid #cccccc;
        font-size: 12px;
        height: 32px;
        vertical-align: bottom;
        margin-left: 10px;
        cursor: pointer;
      }
    }
}    
    .gooditem{
      margin-bottom:10px;
      cursor: pointer;
      border:1px solid transparent;
      /*border-bottom: 1px solid #ccc;
      height:80px;*/
    }
    /*.gooditem:hover{
      border-bottom:1px solid #333;
    }*/
    .goods_image{
      position:relative;
      width:90px;
      height:90px;
      border-radius: 10px;
    }
    .goods_number{
      width:20px;
      height:20px;
      border-radius: 50%;
      background-color:#333;
      color:white;
      position:absolute;
      right: -4px;
      top: -8px;
      text-align: center;
      line-height: 20px;
    }
    .goods_number_right{
      width:20px;
      height:20px;
      border-radius: 50%;
      background-color:#333;
      color:white;
      text-align: center;
      line-height: 20px;
      display: inline-block;
      margin-right: 4px;
    }
    .goods_info{
      width:100%;
      position:relative;
    }
    .goods_info.noeditMode:hover{
      z-index:1000;
    }
    .goods_delete{
      position: absolute;
      bottom: -8px;
      left: 10px;
      height: 32px;
      width: 80px;
      text-align: center;
      border: 1px solid #DEE1EB;
      border-radius: 3px;
      background: #F3F3F9;
      font-size: 12px;
      color: #686B73;
      cursor: pointer;
    }
    .goods_info.noeditMode .goods_delete{
      display:none;
    }
    .goods_info.noeditMode:hover .goods_delete{
      display:block;
    }
    .goods_params{
      width:100%;
      display:flex;
      justify-content: space-between;
    }
    .goods_params.noeditMode{
      display: block;
    }
    .goods_params.hasPicture{
      width:calc(100% - 95px);
    }
    .goods_params_row.noeditMode{
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      padding-right:10px;
      height:100%;
    }
    .goods_info_row{
      display:flex;
      justify-content: space-between;
    }
    .goods_info_row.editMode{
      margin-bottom: 10px;
    }
    .goods_info_row el-input{
      width:190px;
    }
    .priceInfo_div{
      padding: 10px 10px 0;
      border-top:1px solid #ccc;
      padding-top:10px;
    }
    .priceInfo_row{
      display: flex;
      justify-content: space-between;
      margin-bottom:10px;
    }
    .priceInfo_row.editMode{
      align-items: center;
      .priceInfo_row_right{
        text-align: right;
      }
    }
    .form_error{
      color: #f56c6c;
      font-size: 12px;
      line-height: 1;
      padding-top: 4px;
    }
    .round_button{
      border: none;
      background: transparent;
      color: #333;
      cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/pages/publish_task/Index.vue